import { socket, socketEmit, socketOff, socketOn } from 'lib/clients/socket';

import onAuthReq from './listeners/authReq/onAuthReq';
import onUserAuth from './listeners/userAuth/onUserAuth';
import onUserInit from './listeners/userInit/onUserInit';
import onDataUpdate from './listeners/dataUpdate/onDataUpdate';
import { onImportsReconnect } from './listeners/dataUpdate/imports';

// Registered straight on the socket, once per page load: this function runs
// again on every re-login and would otherwise stack a copy of the handler.
let isReconnectHandlerRegistered = false;

export default (sessionToken = null, sessionClientId = null) => {
  try {
    socketEmit('user-init', { ok: true }, { reemitOnReconnect: true });

    socketOn('user-init', (response) => onUserInit(response, sessionToken, sessionClientId));
    socketOn('auth-req', () => onAuthReq());

    socketOn('user-auth', () => onUserAuth());

    socketOn('data-update', onDataUpdate);

    if (!isReconnectHandlerRegistered) {
      isReconnectHandlerRegistered = true;
      socket.on('connect', onImportsReconnect);
    }

    return () => {
      socketOff('user-auth', { sessionToken, sessionClientId });
    };
  } catch (error) {
    console.error(error);
  }
};
